import { LayoutDashboard, Users, Settings, ClipboardList, LogOut, ArrowLeft, CalendarDays, Wallet, BookOpen, Tag, Receipt, Contact, FileText, UserCheck } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { BrandMark } from "@/components/Logo";

const NAV = [
  { path: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { path: "/admin/shifts", label: "All Shifts", icon: ClipboardList },
  { path: "/admin/daily", label: "Daily Reports", icon: CalendarDays },
  { path: "/admin/cash", label: "Staff Cash Reconciliation", icon: Wallet },
  { path: "/admin/cashbook", label: "Cash Book", icon: BookOpen },
  { path: "/admin/expenses", label: "Expenses", icon: Receipt },
  { path: "/admin/credit/entry", label: "Credit Bill Entry", icon: BookOpen },
  { path: "/admin/credit/receipts", label: "Receive Payments", icon: Wallet },
  { path: "/admin/credit/customers", label: "Credit Customers", icon: Users },
  { path: "/admin/credit/invoices", label: "Credit Invoices", icon: FileText },
  { path: "/admin/customers", label: "Customer Master", icon: Contact },
  { path: "/admin/credit/master", label: "Rates & Products", icon: Tag },
  { path: "/admin/employees", label: "Employees", icon: Users, adminOnly: true },
  { path: "/admin/attendance", label: "Attendance", icon: UserCheck },
  { path: "/admin/settings", label: "Settings", icon: Settings, adminOnly: true },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const items = NAV.filter((i) => !i.adminOnly || user?.role === "admin");
  return (
    <div className="min-h-screen bg-slate-50 lg:flex">
      <aside className="lg:w-64 lg:min-h-screen bg-white border-r border-slate-200 lg:sticky lg:top-0">
        <div className="p-4 border-b border-slate-100 flex items-center gap-3">
          <BrandMark />
        </div>
        <nav className="p-2 flex lg:flex-col overflow-x-auto lg:overflow-visible gap-1">
          {items.map((item) => {
            const Icon = item.icon;
            const active = item.exact
              ? loc.pathname === item.path
              : loc.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/ /g, "-")}`}
                className={`flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium whitespace-nowrap transition-colors ${
                  active
                    ? "bg-[color:var(--bpcl-blue)] text-white"
                    : "text-slate-600 hover:bg-slate-100"
                }`}
              >
                <Icon className="w-4 h-4" />
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 lg:mt-auto lg:absolute lg:bottom-0 lg:w-64 border-t border-slate-100 bg-white">
          <div className="text-xs text-slate-500 mb-2">
            Signed in as <span className="font-medium text-slate-800">{user?.name}</span>
          </div>
          <div className="flex gap-2">
            <Button
              size="sm"
              variant="outline"
              onClick={() => nav("/dashboard")}
              className="flex-1 rounded-full"
              data-testid="go-staff-btn"
            >
              <ArrowLeft className="w-3.5 h-3.5 mr-1" /> Staff view
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={logout}
              data-testid="admin-logout-btn"
              aria-label="Logout"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </aside>
      <main className="flex-1 p-4 lg:p-8 max-w-7xl">{children}</main>
    </div>
  );
}
